export const ROOT_PATH = '/workspaces';
export const COMPLETION_MIN = 2;
export const PREVIEW_COUNT_S = 5;
export const PREVIEW_COUNT_M = 10;
export const PREVIEW_COUNT_L = 25;
export const MAX_RESULT_COUNT = 1000;
export const IMPORT_ROLES = ['admin',];